import { Capacitor } from '@capacitor/core';

export const reloadPage = (): void => {
  const isNative = Capacitor.getPlatform() !== 'web';

  if (isNative) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('__reload', Date.now().toString());
    window.location.replace(currentUrl.toString());
  } else {
    window.location.reload();
  }
};
